<div class="tooltip-box" [class.modals-show]="isInfoPaymentModal">
    <a class="close-modal" (click)="closeModal()"></a>

    <span class="info-text">
        <h4>Maslotochka є:</h4>
    національним клієнтом Нової пошти і має знижку на доставку.
    Оплачуючи за пересилку нової пошти через Maslotochka ви використовуєте нашу знижку, для цього треба оплатити за
    доставку на сайті Maslotochka.com Точна сума до сплати з урахуванням знижки буде сформована на сайті Maslotochka після створення ТТН.
  </span>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
